import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ProductImage from '4all-ui/components/ProductImage';
import * as styles from './style';
import { FILE_EXTENSIONS_WHITELIST, UPLOAD_FILE_MAX_SIZE } from '../../helpers/constants';
import Helper from '../../helpers/Helper';

class ImageUpload extends PureComponent {
  constructor(props) {
    super(props);

    this.inpFile = React.createRef();
    this.state = {
      fileUrl: '',
    };
  }

  onChange = event => {
    const file = event.target.files[0];

    if (file) {
      if (this.isSizeValid(file)) {
        if (this.state.fileUrl) {
          URL.revokeObjectURL(this.state.fileUrl);
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.setState({
            fileUrl: reader.result.length ? reader.result : '',
          });
          this.props.onChangeFile({ file, base64: reader.result });
        };
      } else {
        this.props.onError('Imagem com tamanho maior que o limite de 2mb');
      }
    }
  };

  componentDidUpdate() {
    if (!this.state.fileUrl.length && this.state.fileUrl !== this.props.fileUrl) {
      this.setState({ fileUrl: this.props.fileUrl });
    }
  }

  isSizeValid = file => {
    return !file || file.size < this.props.maxSize;
  };

  removeImage = () => {
    URL.revokeObjectURL(this.state.fileUrl);
    this.setState({ fileUrl: '' }, this.props.onChangeFile(''));
  };

  getExtensionsName = (ext, index) => {
    const { extensions } = this.props;
    if (extensions.length === 1 || index === 0) {
      return ext.toLocaleUpperCase();
    }
    if (index === extensions.length - 1) {
      return ` ou ${ext.toLocaleUpperCase()}`;
    }
    return `, ${ext.toLocaleUpperCase()}`;
  };

  openFileSelection = () => {
    if (this.inpFile.current) {
      this.inpFile.current.click();
    }
  };

  render() {
    const { fileUrl } = this.state;
    const { id, width, height, file, extensions, maxSize } = this.props;

    return (
      <Fragment>
        <styles.Container width={width}>
          <styles.ImageContainer bgColor={!fileUrl} width={width} height={height}>
            <styles.LabelContainer htmlFor={id}>
              <ProductImage
                image={fileUrl}
                size="150px"
                emptyText="Imagem do Produto"
                iconSize="50px"
                fontSize="13px"
                backgroundColor="#f9f9f9"
                customStyles={{
                  maxWidth: fileUrl ? '100%' : 150,
                  maxHeight: fileUrl ? '100%' : 150,
                  width: fileUrl ? 'auto' : 150,
                  height: fileUrl ? 'auto' : 150,
                  '.product-image-4all__text': {
                    color: '#a0a0a0',
                    fontWeight: 600,
                    lineHeight: '18px',
                    maxWidth: 100,
                  },
                }}
              />
            </styles.LabelContainer>

            <styles.InputFile
              id={id}
              value={file}
              ref={this.inpFile}
              type="file"
              onChange={this.onChange}
              accept={extensions.join(',')}
            />
          </styles.ImageContainer>
          <styles.Rules>
            <styles.RuleText>{extensions.map(this.getExtensionsName).join('')}</styles.RuleText>
            <styles.RuleSeparator />
            <styles.RuleText>Máximo de {Helper.formatFileSize(maxSize)}Mb</styles.RuleText>
          </styles.Rules>
          <styles.LinkButton className="image-upload-button" onClick={this.openFileSelection}>
            {fileUrl ? 'Trocar Imagem' : 'Carregar Imagem'}
          </styles.LinkButton>
        </styles.Container>
      </Fragment>
    );
  }
}

ImageUpload.propTypes = {
  id: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  file: PropTypes.any,
  fileUrl: PropTypes.string,
  onChangeFile: PropTypes.func.isRequired,
  close: PropTypes.bool,
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  onError: PropTypes.func.isRequired,
};

ImageUpload.defaultProps = {
  id: 'inp-upload-img',
  width: '150px',
  height: '150px',
  close: true,
  extensions: FILE_EXTENSIONS_WHITELIST,
  maxSize: UPLOAD_FILE_MAX_SIZE,
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/ImageUpload/index.js